export enum SamplingMethod {
  AQL = 'AQL',
  FULL_LOT = 'FULL_LOT',
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}

export enum InspectionLevelCode {
  LEVEL_I = 'LEVEL_I',
  LEVEL_II = 'LEVEL_II',
  LEVEL_III = 'LEVEL_III',
  POSITIVE_RELEASE = 'POSITIVE_RELEASE',
  FIXED_SAMPLE_SIZE = 'FIXED_SAMPLE_SIZE',
}

export interface InspectionLevel {
  id: string;
  name: string;
  value?: number;
  code?: InspectionLevelCode | string;
  samplingMethod?: SamplingMethod | string;
}
